module.exports = __webpack_public_path__ + "static/media/Statua_059.2730a674.jpg";